import { useForm } from '@inertiajs/react'
import type { ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import AppLayout from '@/layouts/AppLayout'
import AccountLayout from '@/layouts/AccountLayout'

interface Props {
  user: { email: string; full_name: string | null; display_name: string }
}

export default function AccountShow({ user }: Props) {
  const { data, setData, patch, processing } = useForm({
    user: {
      full_name: user.full_name ?? '',
    },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    patch('/account')
  }

  return (
    <div className="max-w-sm">
      <h1 className="text-2xl font-semibold mb-6">Profile</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" value={user.email} disabled />
        </div>
        <div className="space-y-2">
          <Label htmlFor="full_name">Full Name</Label>
          <Input
            id="full_name"
            value={data.user.full_name}
            onChange={(e) => setData('user', { ...data.user, full_name: e.target.value })}
            placeholder="Jane Doe"
          />
        </div>

        <Button type="submit" disabled={processing}>
          {processing ? 'Saving...' : 'Save'}
        </Button>
      </form>
    </div>
  )
}

AccountShow.layout = (page: ReactNode) => (
  <AppLayout>
    <AccountLayout>{page}</AccountLayout>
  </AppLayout>
)
